import {DownloadPageData} from '../types';

export const downloadPageData_Launch: DownloadPageData = {
  text: {
    en: '# Welcome to ![titleLogo](/logo.svg)\n ## Launch the app and start showing off your skills 🤩',
    nl: '# Welkom bij ![titleLogo](/logo.svg)\n ## Open de app en toon je skills 🤩',
  },
  platforms: {
    iOS: {
      url: 'https://apps.apple.com/us/app/slipapp/id6449608428',
    },
    Android: {
      url: 'https://play.google.com/store/apps/details?id=com.slipbv.slipapp&utm_source=website&utm_campaign=launch-2023&pcampaignid=launch-2023-webpage',
    },
  },
};
